import axiosInstance from "@/api/axiosInstance";
import {
  FetchPromotionCoveragePreviewRequest,
  FetchPromotionCoveragePreviewResponse,
} from "./types";

export const fetchPromotionCoveragePreview = async (
  requestData: FetchPromotionCoveragePreviewRequest,
): Promise<FetchPromotionCoveragePreviewResponse> => {
  const url = `/api/private/enrollments/${requestData.enrollmentId}/promotion-coverage-preview`;

  const response =
    await axiosInstance.get<FetchPromotionCoveragePreviewResponse>(url);

  return response.data;
};
